import React from 'react';
import theme from './SuccessScreen.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons';
import { TranslatableText } from '@/types';

interface SuccessScreenProps {
    text: TranslatableText;
}

const SuccessScreen: React.FC<SuccessScreenProps> = ({ text }) => {
    return (
        <div className={theme.successContainer}>
            <FontAwesomeIcon icon={faCheckCircle} size={'10x'} />
            <h5>{text}</h5>
        </div>
    );
};

export default SuccessScreen;
